import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import ResetGuestLinkModal from '../components/pages/meeting-room/reset-guest-link/content';
import EditPropertiesModal from './EditMeetingRoomProperties.js';
import DeleteMeetingRoomModal from '../components/pages/meeting-room/delete/content.js';

export const MeetingRoomsAdminModals = (props) => {
  let modals = '';
  const dispatch = useDispatch();

  const meetingRoomForm = useSelector((state) => state.meetingRoomReducer.meetingRoomForm);
  const showMeetingRoomResetGuestLink = useSelector((state) => state.modalReducer.showMeetingRoomResetGuestLink);
  const showEditMeetingRoomModal = useSelector((state) => state.modalReducer.showEditMeetingRoomModal);
  const showDeleteMeetingRoomModal = useSelector((state) => state.modalReducer.showDeleteMeetingRoomModal);

  if (props.meetingRoom && props.meetingRoom.permissions && props.meetingRoom.permissions.length > 0) {
    const hasEditMRAccess = props.meetingRoom.permissions.indexOf('EDIT') > -1;
    const hasViewMRAccess = props.meetingRoom.permissions.indexOf('VIEW') > -1;
    const hasDeleteMRAccess = props.meetingRoom.permissions.indexOf('DELETE') > -1;

    if (hasEditMRAccess && hasViewMRAccess) {
      modals = (
        <div>
          {showMeetingRoomResetGuestLink ? (
            <ResetGuestLinkModal selectedMeetingRoom={meetingRoomForm} dispatch={dispatch} />
          ) : (
            ''
          )}
          {showEditMeetingRoomModal ? (
            <EditPropertiesModal meetingRoomForm={meetingRoomForm} dispatch={dispatch} />
          ) : (
            ''
          )}
          {showDeleteMeetingRoomModal ? (
            <DeleteMeetingRoomModal
              meetingRoomForm={meetingRoomForm}
              cbAfterDeletion={props.cbAfterDeletion}
              dispatch={dispatch}
            />
          ) : (
            ''
          )}
        </div>
      );
    }
  }
  return modals;
};

export default MeetingRoomsAdminModals;
